export const educationData = [
  {
    id: 1,
    institution: "Technocrats Institute of Technology,BHOPAL",
    course: "Bachelor of Technology",
    startYear: "2018",
    endYear: "2022",
  },

  {
    id: 2,
    institution: "B.S.S INTER COLLEGE, BEGUSARAI",
    course: "INTERMEDIATE",
    startYear: "2017",
    endYear: "2018",
  },
  {
    id: 3,
    institution: "Mahant Mitthu Das High School, SALKHUA",
    course: "Higher Secondary Education",
    startYear: "2013",
    endYear: "2014",
  },
];
